<template>
  <div>
    <h1 style="font-size: xx-large; line-height: 35px; font-weight: bold;" :style="{ color: $ajustes.colorTexto2 }">
      QUIENES SOMOS</h1>
    <h1 style="font-size:large; line-height: 35px; font-weight: normal;" :style="{ color: $ajustes.colorTexto2 }">
      Ayudamos a brindar excelencia</h1>
    <v-row class="pt-2 ">
      <v-col v-if="false" class="pa-5 " lg="4" md="4" sm="4" cols="12">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">HISTORIA</h1>
          <span class="mt-2" style="font-size: small;">{{ propInstituto.historia }}</span>
        </v-container>
      </v-col>
      <v-col class="pa-5" lg="6" md="6" sm="6" cols="12">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">MISIÓN</h1>
          <span class="mt-2" style="font-size: small;">{{ propInstituto.mision }}</span>
        </v-container>
      </v-col>
      <v-col class="pa-5" lg="6" md="6" sm="6" cols="12">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">VISIÓN</h1>
          <span class="mt-2" style="font-size: small;">{{ propInstituto.vision }}</span>
        </v-container>
      </v-col>
    </v-row>
    <v-row class="pl-6 pr-6">
      <v-col class="ma-0 pa-2" lg="12" md="12" sm="12" cols="12" style="height: 100%;">
        <h1 v-if="fichas.length != 0" style="text-align: justify; line-height: 20px; font-size: 15pt;">INSTRUCTORES</h1>
      </v-col>
      <v-col class="ma-0 pa-2" v-for="ficha in fichas" :key="ficha.id" lg="6" md="6" sm="6" cols="12">
        <v-container class="pa-1" style="align-items: center;align-items: center;">
          <ficha :propFicha="ficha" />
        </v-container>
      </v-col>
    </v-row>
    <div style="width: 100%;" class="center mt-7 mb-5">
      <v-btn class="pa-6" :color="$ajustes.colorTexto2" :style="{ color: $ajustes.colorTexto1 }"
        @click="$router.push({ name: 'Nosotros' })">
        <h1>VER INFORMACIÓN</h1>
      </v-btn>
    </div>
  </div>
</template>
<script>
import ficha from "@/components/template/ficha";
import axios from 'axios';

export default {
  components: {
    ficha
  },
  props: {
    propInstituto: { type: Object },
  },
  data() {
    return {
      fichas: [],
      //       fichas: [
      //         {
      //           id: "1",
      //           imagen_ruta: "https://api.insegt.com.ec/public/uploads/nosotros/drpatriciocumba.png",
      //           cargo: "DIRECTIVO",
      //           nombre: "DR. PATRICIO RAUL CUMBA ZARATE",
      //           titulo: "PhD en SEGURIDAD PUBLICA",
      //           mensaje: `“El conocimiento es poder”, Francis Bacon (1561-1626)
      // En esta época del ser humano, siglo XXI, donde la información está al alcance de todos, no podemos quedarnos estáticos e inmóviles; necesitamos obligadamente ir en el camino profesional y académico de alto nivel, de tal forma que dejemos una huella profunda con las personas que nos rodean y en el entorno que nos cobija.
      // Hoy es la oportunidad de dejar el conformismo y dedicar nuestro tiempo a capacitarnos, a prepararnos con una visión global, que empuje a los que nos rodean y se imbuyan de esta voluntad.
      // Ánimo a mis lectores a practicar una cultura de alto nivel educativo.`,
      //         },

      //       ],
      instituto: {
        historia: "",
        mision: "",
        vision: "",
      }
    };
  },
  mounted() {
    this.obtenerInstituto()
    this.obtenerInstructores()
  },

  created() { },
  computed: {
  },
  methods: {
    async obtenerInstituto() {
      await axios.get("/obtener_instituto")
        .then((response) => {
          if (response.data) {
            this.ponerInstituto(response.data.data)
          }
        })
        .catch(() => {
          this.ponerInstitutoRecomendado(this.instituto_recomendado)
        });
      this.loading = false
    },
    async obtenerInstructores() {
      await axios.get("/obtener_instructores")
        .then((response) => {
          if (response.data) {
            this.fichas = response.data.data.filter(instructor => instructor.destacado & instructor.habilitado);
          }
        })
        .catch(() => {
          this.fichas = []
        });
      this.loading = false
    },

    ponerInstituto(aux) {
      this.instituto.mision = aux.mision
      this.instituto.vision = aux.vision
      this.instituto.historia = aux.historia
    },
    async getAllCourses() {
      // var response = await axios.getAllCourses()
      //this.fichas = response.data
    },
    continuar() { },
    close() { },
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
